import Col from 'antd/es/grid/col'
import { useEffect, useRef, useState } from 'react'
import { usePlacesWidget } from 'react-google-autocomplete' //import { usePlacesWidget } from '@react-google-maps/api'
import BaseField from './BaseField'
import './FieldAddress.scss'


export default function FieldAddress(props) {
  /* Input Text
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * required = <boolean> Optional
   * name = <string> Required
   * value = <string> Required
   * placeholder = <string> Optional
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * onBlur = <function()> Optional
   * disabled = <boolean> Optional
   * readOnly = <boolean> Optional
   * prepend = <string> Optional
   * append = <string> Optional
   * maxLength = <integer> Optional
   * horizontal = <boolean> Optional
   * horizontalLabelSize = <int [1-23]> Optional (Default = 6)
   * forceValidPlace = <boolean> Optional (Default = true)
   * fields = Array<string> Optional (default = ["formatted_address"])
   * types = Array<string> Optional (default = ["geocode", "establishment"])
   */
  const fields = props.fields || ["formatted_address"]
  const types = props.types || ["geocode", "establishment"]
  const showMap = props.showMap || false
  const [savedValue, setSavedValue] = useState(props.value)
  const [tempValue, setTempValue] = useState(props.value)
  const timeoutRef = useRef()
  const isEditing = useRef()

  // Check for new value from props
  useEffect(() => {
    if (props.value !== savedValue) {
      // Set State
      setSavedValue(props.value)
      setTempValue(props.value)
    }
  }, [props.value])

  // Google Autocomplete
  const onPlaceSelected = place => {
    // Clear Timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    // Get Place
    const value = place?.formatted_address || ""
    // Set State
    if (value || !isEditing.current) {
      setTempValue(value)
    }
    // Run onChange
    if (typeof props.onChange === "function") {
      setSavedValue(value)
      props.onChange({ target: { value: value } })
    }
  }

  const { ref, autocompleteRef } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    onPlaceSelected: onPlaceSelected,
    options: { types, fields },
  })

  // Functions
  const onChange = event => {
    // Set State
    isEditing.current = true
    setTempValue(event.target.value)
    // Clear Selected Place
    if (autocompleteRef.current?.get?.('place')) {
      autocompleteRef.current?.set?.('place')
    }
    // Clear Value
    if (props.value !== "" && typeof props.onChange === "function") {
      setSavedValue("")
      props.onChange({ target: { value: "" } })
    }
  }

  const onBlur = event => {
    // Set State
    isEditing.current = false
    // Force Place Check (delayed to wait for Google API to get a Place if one is selected)
    if (props.forceValidPlace === undefined || props.forceValidPlace) {
      // Clear Timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        autocompleteRef.current?.notify?.('place')
      }, 500)
    }
    // Run onBlur
    if (typeof props.onBlur === "function") {
      props.onBlur(event)
    }
  }

  // Render
  const input = (
    <input
      ref={ref}
      className={
        "form-control custom-field-input" + (
          props.valid === true ? " is-valid" : props.valid === false ? " is-invalid" : ""
        )
      }
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      name={props.name}
      type="text"
      placeholder={props.placeholder}
      value={tempValue || (tempValue !== null && tempValue !== undefined ? tempValue : "")}
      required={props.required && props.valid === false}
      onChange={onChange}
      onBlur={onBlur}
      disabled={props.disabled}
      readOnly={props.readOnly}
      maxLength={props.maxLength}
      autoFocus={props.autoFocus}
    />
  )

  const Map = () => {
    return (
      <>
        <div className='bg-blue text-center pt-5 text-white' style={{height: '250px'}}>MAP HERE</div>
      </>
    )
  }

  return (
    <>
      <BaseField
        className={props.className}
        label={props.label}
        input={
          props.prepend || props.append ? (
            <div className="input-group">
              {props.prepend ? (
                <div className="input-group-prepend">
                  <span className="input-group-text">{props.prepend}</span>
                </div>
              ) : null}
              {input}
              {props.append ? (
                <div className="input-group-append">
                  <span className="input-group-text">{props.append}</span>
                </div>
              ) : null}
            </div>
          ) : input
        }
        disabled={props.disabled}
        readOnly={props.readOnly}
        required={props.required}
        valid={props.valid}
        validMessage={props.validMessage}
        invalidMessage={props.invalidMessage}
        help={props.help}
        helpAboveInput={props.helpAboveInput}
        horizontal={props.horizontal}
        horizontalLabelSize={props.horizontalLabelSize}
      />
      {showMap ? props?.horizontal ? <><Col offset={props?.horizontalLabelSize}><Map/></Col></> : <Map/> : null}
    </>
  )
}
